import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Meses } from '@shared/enums/Meses';
import { HolidayComponent } from './holiday/holiday.component';
import { DatePipe } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { ExportExcelServiceService } from '@shared/exportar-excel/export-excel-service.service';
import { ManagementService } from '@management/management.service';
import { FeriadoDTO } from "@shared/models/facturacion/FeriadoDTO";
import { MessageService } from "@shell/message.service";
import { UsuarioService } from "@account/usuario.service";
import {AccionModificacionFeriado} from "@shared/enums/AccionModificacionFeriado";

interface holidays {
  day: number;
  reason: string;
  isHoliday: boolean;
}
@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrl: './calendar.component.scss'
})
export class CalendarComponent implements OnInit {

  _meses = Meses;
  days = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];
  months = Object.values(Meses).filter((v) => isNaN(Number(v)));
  selectedMonth: string = '';
  selectedYear: number = new Date().getFullYear();
  calendar: { date: number; detail: string; isHoliday: boolean }[] = [];
  selectedDate: Date | null = null;
  currentDate: Date = new Date();
  loading: boolean = false;
  arrayHolidays: holidays[];
  arrayResponse: FeriadoDTO[];
  _year: number = 0;

  constructor(
    private activeModal: NgbModal,
    private spinner: NgxSpinnerService,
    private datePipe: DatePipe,
    private excelService: ExportExcelServiceService,
    private messageService: MessageService,
    private managementService: ManagementService,
    private usuarioService: UsuarioService) { }

  ngOnInit(): void {
    this.selectedMonth = this.getNameMonth(new Date().getMonth() + 1);
    this.updateCalendar();
  }

  handleSpinner(show: boolean) {
    show ? this.spinner.show('loading') : this.spinner.hide('loading');
    this.loading = show;
  }

  async updateCalendar() {
    this.selectedDate = new Date();
    const month = this.getNumberMonth(this.selectedMonth) - 1;
    const year = this.selectedYear;
    this.currentDate.setFullYear(year);
    this.currentDate.setMonth(month);
    try {
      this.arrayHolidays = await this.getFeriados(year, month + 1);
    }
    catch (error) {
      this.arrayHolidays = [];
      this.handleSpinner(false);
      this.messageService.showErrorMessage("Error en la llamada a backend: " + error.message + " descripcion: " + error.descripcion);
    }
    this.calendar = this.generateCalendar(year, month, this.arrayHolidays);
  }

  descargarHistorial() {
    const nombreArchivo = "Historial_calendario_" + this.selectedYear;
    const datosExcel=[
      ["Fecha Feriado", "Fecha y hora modificación", "Responsable", "Tipo de acción", "Motivo", "Activo"]
    ];

    // Generar filas
    this.arrayResponse.forEach(feriado => {
      // Si tiene modificaciones
      if (feriado.modificaciones?.length) {
        feriado.modificaciones.forEach(modificacion => {
          const fila = [
            this.datePipe.transform(feriado.fecha, 'dd/MM/yyy'),
            this.datePipe.transform(modificacion.fechaHora, "dd/MM/yyy HH:mm a"),
            this.obtenerResponsable(modificacion.responsable),
            this.obtenerAccion(modificacion.accion).toString(),
            modificacion.motivo || '--',
            modificacion.activo ? 'Sí' : 'No'
          ];
          datosExcel.push(fila);
        });
      } else {
        // Si no tiene modificaciones, mostrar solo datos base
        datosExcel.push([
          this.datePipe.transform(feriado.fecha, 'dd/MM/yyy'),
          'Sin modificaciones',
          '--',
          '--',
          feriado.motivo,
          feriado.activo ? 'Sí' : 'No'
        ]);
      }
    });
    // Convierto datosExcel a JSON para su correcta exportación
    const [cabeceras, ...filas] = datosExcel; // Separar cabeceras y filas
    const jsonData = filas.map(fila => {
      const filaObj: any = {};
      cabeceras.forEach((cabecera, index) => {
        filaObj[cabecera] = fila[index];
      });
      return filaObj;
    });
    //llamada a backend
    this.excelService.exportAsExcelFile(jsonData, nombreArchivo, true);
  }

  obtenerResponsable(responsable: string): string {
    if (typeof responsable === 'string' && responsable.trim().startsWith('{')) {
      try {
        const obj = JSON.parse(responsable);
        return obj.nombresCompletos || '--';
      } catch (error) {
        console.error('Error al parsear JSON en responsable:', responsable, error);
        return '--';
      }
    }
    return responsable || '--';
  }

  obtenerAccion(accion: AccionModificacionFeriado) {
    return AccionModificacionFeriado[accion]
  }

  async getFeriados(year: number, month: number): Promise<holidays[]> {
    this.handleSpinner(true);
    if (this._year !== year) {
      this.arrayResponse = await this.managementService.getFeriados(year);
      this._year = year;
    }

    const nuevoArray: holidays[] = this.arrayResponse
      .filter(item => {
        const fecha = new Date(item.fecha);
        const mes = fecha.getMonth() + 1;
        const año = fecha.getFullYear();
        console.log('Fecha procesada:', fecha, 'Mes:', mes, 'Año:', año);
        return mes === month && año === year;
      })
      .map(item => ({
        day: new Date(item.fecha).getUTCDate(),
        reason: item.motivo,
        isHoliday: item.activo
      }));

    this.handleSpinner(false);
    return nuevoArray;
  }

  generateCalendar(year: number, month: number, holidays: holidays[]): { date: number; detail: string; isHoliday: boolean }[] {
    const firstDay = new Date(year, month, 1).getDay() === 0 ? 6 : new Date(year, month, 1).getDay() - 1; // determina la posición donde arranca el mes - por ej: 0 = Domingo | 1 = Lunes.... 6 = Sábado
    const daysInMonth = new Date(year, month + 1, 0).getDate(); // determina los días del mes - por ej: 31, 30 o 29

    const calendar = [];
    let week = [];

    // armo el arreglo de las semanas
    for (let i = 0; i < firstDay; i++) {
      week.push({ date: null, detail: '', isHoliday: false });
    }

    // armo la matriz de los días
    for (let day = 1; day <= daysInMonth; day++) {
      const holiday = holidays.find(h => h.day === day);
      week.push({ date: day, detail: holiday?.reason || '', isHoliday: holiday?.isHoliday });

      if (week.length === 7) {
        calendar.push(week);
        week = [];
      }
    }

    if (week.length) {
      while (week.length < 7) {
        week.push({ date: null, detail: '', isHoliday: false });
      }
      calendar.push(week);
    }

    return calendar;
  }

  selectDate(day) {
    this.selectedDate = new Date(this.currentDate.getFullYear(), this.getNumberMonth(this.selectedMonth) - 1, day.date);
    if (this.selectedDate) {
      const modal = this.activeModal.open(HolidayComponent, { centered: true, backdrop: 'static' });
      modal.componentInstance.detail = day.detail;
      modal.componentInstance.activo = day.isHoliday ?? true;
      modal.componentInstance.responsable = this.usuarioService.getNombresCompletosUsuario();
      modal.componentInstance.selectedDate = this.selectedDate;
      modal.result.then((result: FeriadoDTO) => {
        // Busco si ya existe un FeriadoDTO con el mismo id
        const feriadoExistente = this.arrayResponse.find(feriado => feriado.id === result.id);

        if (feriadoExistente) {
          feriadoExistente.id = result.id;
          feriadoExistente.motivo = result.motivo;
          feriadoExistente.activo = result.activo;
          feriadoExistente.fecha = result.fecha;
          const ultimaModificacion = result.modificaciones[result.modificaciones.length - 1];
          feriadoExistente.modificaciones.push(ultimaModificacion);
        } else {
          this.arrayResponse.push(result);
        }
        this.updateCalendar();
      }).catch((reason) => {
        console.log('Modal cerrado sin enviar objeto:', reason);
      });
    }
  }

  getNumberMonth(mes: string) {
    return Number(this._meses[mes]);
  }

  getNameMonth(mes: number) {
    return this._meses[mes];
  }

  weekend(day: number) {
    const weekday = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), day).getDay();
    return weekday === 0 || weekday === 6;
  }
}
